export const getSourceChannelLabel = (sourceChannel: string) => {
  switch (sourceChannel) {
    case 'inbound_call':
      return 'Inbound Call'
    case 'inbound_email':
      return 'Inbound Email'
    case 'outbound_call':
      return 'Outbound Call'
    case 'outbound_email':
      return 'Outbound Email'
    default:
      return sourceChannel
  }
}
